import {
  Component, Inject, OnDestroy, OnInit,
} from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog, MatDialogRef,
} from '@angular/material/dialog';
import { CatalogSuggestionsService } from 'src/app/services/catalog-suggestions.service';
import { EntityService } from 'src/app/services/entity.service';
import { formatDate } from 'src/app/utils';

@Component({
  selector: 'app-catalog-suggestions-details',
  templateUrl: './catalog-suggestions-details.component.html',
  styleUrls: [ './catalog-suggestions-details.component.scss' ],
})
export class CatalogSuggestionsDetailsComponent implements OnInit, OnDestroy {
  course: any = {
    catalogSuggestionId: '',
    name: '',
    creditHours: '',
    courseType: '',
    instructor: '',
    cost: '',
    webUrl: '',
    description: '',
    async: false,
    virtual: false,
    anytime: false,
    location: '',
    roomNumber: '',
    courseDate: '',
    startTime: '',
    endTime: '',
  }
  isLoading: any;
  catalogSuggestionSubscription: any;
  entityTimezoneSubscription: any;
  showUploadDocumentsModal = false;

  constructor(
    public dialogRef: MatDialogRef<CatalogSuggestionsDetailsComponent>,
    public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
    private catalogSuggestionsService: CatalogSuggestionsService,
    private entityService: EntityService,
  ) { }

  ngOnInit(): void {
    if (!this.entityService.getLocalTimezone()) {
      this.entityService.getEntity('Config');
      this.entityTimezoneSubscription = this.entityService.entityData$.subscribe((entity: any) => {
        if (!entity) return;
        this.loadCatalogSuggestion();
        this.entityTimezoneSubscription?.unsubscribe();
      });
    }
    this.loadCatalogSuggestion();
  }

  loadCatalogSuggestion(): void {
    this.isLoading = true;
    this.catalogSuggestionSubscription = this.catalogSuggestionsService.getCatalogSuggestion(this.data.id).subscribe({
      next: (response: any) => {
        try {
          // The response structure: data is the course; item may be in CourseItems[0] or items[0]
          const course = response?.data || {};
          const courseItem = course?.CourseItems?.[0] ?? course?.items?.[0] ?? {};
          
          const isAsync = courseItem?.preRecordedOption === 'ASYNC';
          const isAnytime = courseItem?.preRecordedOption === 'ANYTIME';
          const tz = this.entityService.getLocalTimezoneWithFallback();
          const startDate = formatDate.parseSessionTimeAsUtc(courseItem?.sessionStartDate);
          const endDate = formatDate.parseSessionTimeAsUtc(courseItem?.sessionEndDate);
          
          this.course = {
            ...course,
            ...courseItem,
            name: course?.courseName || '',
            creditHours: course?.trackingValue || '',
            courseType: course?.CourseType?.courseType || course?.courseType || '',
            instructor: courseItem?.instructor || null,
            cost: course?.courseCost || null,
            webUrl: courseItem?.hyperlink || null,
            description: course?.courseDescription || '',
            async: isAsync,
            virtual: courseItem?.virtualFlag === 1,
            anytime: isAnytime,
            location: courseItem?.location || '',
            roomNumber: courseItem?.roomNumber || null,
            courseDate: isAsync ? 'Async' : (formatDate.asDateLocal(courseItem?.dateOffered) || ''),
            startTime: isAnytime ? 'Anytime' : (startDate ? formatDate.asTimeWithTimezone(startDate, tz) : ''),
            endTime: isAnytime ? 'Anytime' : (endDate ? formatDate.asTimeWithTimezone(endDate, tz) : ''),
            // Ensure CourseItems is included
            CourseItems: course?.CourseItems || [],
            // Preserve IDs
            courseItemId: courseItem?.id || null,
            courseId: course?.id || courseItem?.courseId || null,
          }
        } catch (error) {
          console.error('Error processing catalog suggestion data:', error);
        } finally {
          this.isLoading = false;
        }
      },
      error: (error: any) => {
        console.error('Error getting catalog suggestion', error);
        this.isLoading = false;
      },
    });
  }


  onDocumentsUploaded(): void {
    // Reload course request data to refresh document list
    this.loadCatalogSuggestion();
  }

  getCourseItemId(): number | null {
    if (this.course?.courseItemId) {
      return Number(this.course.courseItemId);
    }
    if (this.course?.CourseItems) {
      if (Array.isArray(this.course.CourseItems) && this.course.CourseItems.length > 0) {
        return Number(this.course.CourseItems[0].id);
      }
      if (typeof this.course.CourseItems === 'object') {
        return Number(this.course.CourseItems.id);
      }
    }
    if (this.course?.id) {
      return Number(this.course.id);
    }
    if (this.course?.course_item_id) {
      return Number(this.course.course_item_id);
    }
    return null;
  }

  openUploadDocumentsModal(): void {
    this.showUploadDocumentsModal = true;
  }

  closeUploadDocumentsModal(): void {
    this.showUploadDocumentsModal = false;
  }

  closeModal(action?: 'approve' | 'deny'): void {
    this.dialogRef.close(action);
  }

  ngOnDestroy(): void {
    this.catalogSuggestionSubscription?.unsubscribe();
    this.entityTimezoneSubscription?.unsubscribe();
  }

}